// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Dashboard_wrapper__320ln","main":"Dashboard_main__1SC3K"};